/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type ListClusterInvitesAuthClusterResponse429ResponseBodyData = {
  message: string;
};

/**
 * Rate limited
 */
export class ListClusterInvitesAuthClusterResponse429ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: ListClusterInvitesAuthClusterResponse429ResponseBodyData;

  constructor(
    err: ListClusterInvitesAuthClusterResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListClusterInvitesAuthClusterResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type ListClusterInvitesAuthClusterResponse409ResponseBodyData = {
  message: string;
};

/**
 * Conflict
 */
export class ListClusterInvitesAuthClusterResponse409ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: ListClusterInvitesAuthClusterResponse409ResponseBodyData;

  constructor(
    err: ListClusterInvitesAuthClusterResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListClusterInvitesAuthClusterResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type ListClusterInvitesAuthClusterResponse404ResponseBodyData = {
  message: string;
};

/**
 * Not found
 */
export class ListClusterInvitesAuthClusterResponse404ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: ListClusterInvitesAuthClusterResponse404ResponseBodyData;

  constructor(
    err: ListClusterInvitesAuthClusterResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListClusterInvitesAuthClusterResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type ListClusterInvitesAuthClusterResponseResponseBodyData = {
  message: string;
};

/**
 * Forbidden
 */
export class ListClusterInvitesAuthClusterResponseResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: ListClusterInvitesAuthClusterResponseResponseBodyData;

  constructor(
    err: ListClusterInvitesAuthClusterResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListClusterInvitesAuthClusterResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type ListClusterInvitesAuthClusterResponseBodyData = {
  message: string;
};

/**
 * Unauthorized
 */
export class ListClusterInvitesAuthClusterResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: ListClusterInvitesAuthClusterResponseBodyData;

  constructor(
    err: ListClusterInvitesAuthClusterResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListClusterInvitesAuthClusterResponseBody";
  }
}

/**
 * Bad request
 */
export type ListClusterInvitesResponseBodyData = {
  message: string;
};

/**
 * Bad request
 */
export class ListClusterInvitesResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: ListClusterInvitesResponseBodyData;

  constructor(
    err: ListClusterInvitesResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListClusterInvitesResponseBody";
  }
}

/** @internal */
export const ListClusterInvitesAuthClusterResponse429ResponseBody$inboundSchema:
  z.ZodType<
    ListClusterInvitesAuthClusterResponse429ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new ListClusterInvitesAuthClusterResponse429ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type ListClusterInvitesAuthClusterResponse429ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ListClusterInvitesAuthClusterResponse429ResponseBody$outboundSchema:
  z.ZodType<
    ListClusterInvitesAuthClusterResponse429ResponseBody$Outbound,
    z.ZodTypeDef,
    ListClusterInvitesAuthClusterResponse429ResponseBody
  > = z.instanceof(ListClusterInvitesAuthClusterResponse429ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ListClusterInvitesAuthClusterResponse409ResponseBody$inboundSchema:
  z.ZodType<
    ListClusterInvitesAuthClusterResponse409ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new ListClusterInvitesAuthClusterResponse409ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type ListClusterInvitesAuthClusterResponse409ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ListClusterInvitesAuthClusterResponse409ResponseBody$outboundSchema:
  z.ZodType<
    ListClusterInvitesAuthClusterResponse409ResponseBody$Outbound,
    z.ZodTypeDef,
    ListClusterInvitesAuthClusterResponse409ResponseBody
  > = z.instanceof(ListClusterInvitesAuthClusterResponse409ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ListClusterInvitesAuthClusterResponse404ResponseBody$inboundSchema:
  z.ZodType<
    ListClusterInvitesAuthClusterResponse404ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new ListClusterInvitesAuthClusterResponse404ResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type ListClusterInvitesAuthClusterResponse404ResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ListClusterInvitesAuthClusterResponse404ResponseBody$outboundSchema:
  z.ZodType<
    ListClusterInvitesAuthClusterResponse404ResponseBody$Outbound,
    z.ZodTypeDef,
    ListClusterInvitesAuthClusterResponse404ResponseBody
  > = z.instanceof(ListClusterInvitesAuthClusterResponse404ResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ListClusterInvitesAuthClusterResponseResponseBody$inboundSchema:
  z.ZodType<
    ListClusterInvitesAuthClusterResponseResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new ListClusterInvitesAuthClusterResponseResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type ListClusterInvitesAuthClusterResponseResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ListClusterInvitesAuthClusterResponseResponseBody$outboundSchema:
  z.ZodType<
    ListClusterInvitesAuthClusterResponseResponseBody$Outbound,
    z.ZodTypeDef,
    ListClusterInvitesAuthClusterResponseResponseBody
  > = z.instanceof(ListClusterInvitesAuthClusterResponseResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ListClusterInvitesAuthClusterResponseBody$inboundSchema: z.ZodType<
  ListClusterInvitesAuthClusterResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new ListClusterInvitesAuthClusterResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type ListClusterInvitesAuthClusterResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ListClusterInvitesAuthClusterResponseBody$outboundSchema:
  z.ZodType<
    ListClusterInvitesAuthClusterResponseBody$Outbound,
    z.ZodTypeDef,
    ListClusterInvitesAuthClusterResponseBody
  > = z.instanceof(ListClusterInvitesAuthClusterResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ListClusterInvitesResponseBody$inboundSchema: z.ZodType<
  ListClusterInvitesResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new ListClusterInvitesResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type ListClusterInvitesResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ListClusterInvitesResponseBody$outboundSchema: z.ZodType<
  ListClusterInvitesResponseBody$Outbound,
  z.ZodTypeDef,
  ListClusterInvitesResponseBody
> = z.instanceof(ListClusterInvitesResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));
